import domReady from '@wordpress/dom-ready';

domReady(() => {
  const accordionHeaders = document.querySelectorAll('.teams-accordion-header');

  accordionHeaders.forEach((header) => {
    header.addEventListener('click', () => {
      const content = header.nextElementSibling;
      const button = header.querySelector('.teams-accordion-header__icon');
      const activeContents = document.querySelectorAll(
        '.teams-accordion-content.active'
      );
      const activeButtons = document.querySelectorAll('.icon-plus.active');

      activeContents.forEach((item) => {
        if (item !== content) {
          item.classList.remove('active');
        }
      });

      activeButtons.forEach((btn) => {
        if (btn !== button) {
          btn.classList.remove('active');
        }
      });

      content.classList.toggle('active');
      button.classList.toggle('active');
    });
  });
});
